import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pdp-notification-overlay',
  templateUrl: './notification-overlay.component.html',
  styleUrls: ['./notification-overlay.component.css']
})
export class NotificationOverlayComponent implements OnInit {

  constructor() { }

  @Input() message: string = '';

  ngOnInit() {
  }

}
